import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, flexAlignCenter, mb, mr, p, w100} from "@pg-design/helpers-css";
import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {ContractorApplication} from "./ContractorApplication";
import {RegisterCompanyButton} from "./RegisterCompanyButton";

const registerImage = require("../images/register.png");

const features = [
    "Dostęp do tysięcy potencjalnych klientów",
    "Profesjonalna wizytówka firmy lub profil specjalisty",
    "Możliwość założenia bloga eksperckiego na portalu",
    "Współpracę z najczęściej cytowanym medium w 2019 roku",
    "Komentarze eksperckie do Rankingu inwestycji"
];

export const ContractorRegister = () => {
    return (
        <section css={contractorRegister}>
            <div css={content}>
                <Text align="center" css={mb(3)} variant="headline_2">
                    Sprawdź, dlaczego warto z nami współpracować:
                </Text>

                <div css={why}>
                    <div css={featuresWrapper}>
                        {features.map((feature, index) => {
                            return (
                                <div css={featureWrapper} key={index}>
                                    <CheckIcon css={mr(2)} size="2" /> <Text variant="body_copy_2">{feature}</Text>
                                </div>
                            );
                        })}
                    </div>

                    <Text align="center" as="h3" variant="headline_4">
                        Stań się widoczny dla naszych klientów!
                    </Text>

                    <RegisterCompanyButton />
                </div>

                <ContractorApplication />
            </div>
        </section>
    );
};

const contractorRegister = (theme: Theme) => css`
    height: 100%;
    ${p(10, 2)};
    background-image: url(${registerImage});
    background-repeat: no-repeat;
    background-position: top 0 center;

    @media (min-width: ${theme.breakpoints.sm}) {
        background-position: top -16rem center;
    }
`;

const content = css`
    max-width: 76.8rem;
    margin: 0 auto;
    ${flexAlignCenter};
    flex-direction: column;
`;

const why = css`
    ${w100};
    ${p(3)};
    background-color: #fff;
    ${elevation(2)};
    ${borderRadius()};
    ${flexAlignCenter};
    flex-direction: column;
    row-gap: ${calculateRemSize(3)};
`;

const featuresWrapper = css`
    ${w100};
    ${flex()};
    flex-direction: column;
    row-gap: ${calculateRemSize(2)};
`;

const featureWrapper = css`
    ${flexAlignCenter};
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {elevation} from "@pg-design/elevation";
import {borderRadius, calculateRemSize, flex, flexAlignCenter, mb, mr, p, w100} from "@pg-design/helpers-css";
import {CheckIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {ContractorApplication} from "./ContractorApplication";
import {RegisterCompanyButton} from "./RegisterCompanyButton";

const registerImage = require("../images/register.png");

const features = [
    "Dostęp do tysięcy potencjalnych klientów",
    "Profesjonalna wizytówka firmy lub profil specjalisty",
    "Możliwość założenia bloga eksperckiego na portalu",
    "Współpracę z najczęściej cytowanym medium w 2019 roku",
    "Komentarze eksperckie do Rankingu inwestycji"
];

export const ContractorRegister = () => {
    return (
        <section css={contractorRegister}>
            <div css={content}>
                <Text align="center" css={mb(3)} variant="headline_2">
                    Sprawdź, dlaczego warto z nami współpracować:
                </Text>

                <div css={why}>
                    <div css={featuresWrapper}>
                        {features.map((feature, index) => {
                            return (
                                <div css={featureWrapper} key={index}>
                                    <CheckIcon css={mr(2)} size="2" /> <Text variant="body_copy_2">{feature}</Text>
                                </div>
                            );
                        })}
                    </div>

                    <Text align="center" as="h3" variant="headline_4">
                        Stań się widoczny dla naszych klientów!
                    </Text>

                    <RegisterCompanyButton />
                </div>

                <ContractorApplication />
            </div>
        </section>
    );
};

const contractorRegister = (theme: Theme) => css`
    height: 100%;
    ${p(10, 2)};
    background-image: url(${registerImage});
    background-repeat: no-repeat;
    background-position: top 0 center;

    @media (min-width: ${theme.breakpoints.sm}) {
        background-position: top -16rem center;
    }
`;

const content = css`
    max-width: 76.8rem;
    margin: 0 auto;
    ${flexAlignCenter};
    flex-direction: column;
`;

const why = css`
    ${w100};
    ${p(3)};
    background-color: #fff;
    ${elevation(2)};
    ${borderRadius()};
    ${flexAlignCenter};
    flex-direction: column;
    row-gap: ${calculateRemSize(3)};
`;

const featuresWrapper = css`
    ${w100};
    ${flex()};
    flex-direction: column;
    row-gap: ${calculateRemSize(2)};
`;

const featureWrapper = css`
    ${flexAlignCenter};
`;
